import * as THREE from 'three';

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
const renderer = new THREE.WebGLRenderer();
renderer.setSize(window.innerWidth, window.innerHeight);
document.getElementById('webgl-container').appendChild(renderer.domElement);

const lasers = [];
const laserCount = 500; // Huge number of lasers for maximum wildness!

// Create lasers with random positions, colors, and behaviors
for (let i = 0; i < laserCount; i++) {
  const geometry = new THREE.BufferGeometry();
  const material = new THREE.LineBasicMaterial({
    color: new THREE.Color(Math.random(), Math.random(), Math.random()),
    opacity: Math.random() * 0.5 + 0.5, // Initial opacity less extreme
    transparent: true
  });

  const positions = [];
  for (let j = 0; j < 2; j++) {
    positions.push(Math.random() * 5 - 2.5); // Random X
    positions.push(Math.random() * 5 - 2.5); // Random Y
    positions.push(Math.random() * 5 - 2.5); // Random Z
  }

  geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
  const laser = new THREE.Line(geometry, material);
  scene.add(laser);
  lasers.push(laser);
}

// Variables for smooth background color transitions
let currentColor = new THREE.Color(Math.random(), Math.random(), Math.random());
let targetColor = new THREE.Color(Math.random(), Math.random(), Math.random());
const colorChangeSpeed = 0.005; // How fast the color transition happens

// Add a starfield background effect
const starGeometry = new THREE.BufferGeometry();
const starMaterial = new THREE.PointsMaterial({
  color: 0x888888,
  size: 0.05,
  transparent: true,
  opacity: 0.5
});

const starCount = 10000;
const starPositions = [];
for (let i = 0; i < starCount; i++) {
  starPositions.push(Math.random() * 1000 - 500); // Random X
  starPositions.push(Math.random() * 1000 - 500); // Random Y
  starPositions.push(Math.random() * 1000 - 500); // Random Z
}
starGeometry.setAttribute('position', new THREE.Float32BufferAttribute(starPositions, 3));

const stars = new THREE.Points(starGeometry, starMaterial);
scene.add(stars);

// Add camera movement and mouse interaction
let mouseX = 0, mouseY = 0;

window.addEventListener('mousemove', (event) => {
  mouseX = (event.clientX / window.innerWidth) * 2 - 1;
  mouseY = -(event.clientY / window.innerHeight) * 2 + 1;
});

camera.position.z = 5;

// Animation loop with more chaotic laser behavior
let time = 0;
function animate() {
  requestAnimationFrame(animate);

  // Update lasers with extreme randomness for both rotation and position
  lasers.forEach((laser) => {
    laser.rotation.x += Math.random() * 0.3; // Increased rotation speed for wildness
    laser.rotation.y += Math.random() * 0.3;
    laser.rotation.z += Math.random() * 0.3;

    // Randomly change the laser color and opacity frequently
    laser.material.color.setRGB(Math.random(), Math.random(), Math.random());
    laser.material.opacity = Math.random() * 0.5 + 0.5;

    // Unrestricted movement: random positions every frame
    laser.position.x += Math.sin(time + Math.random() * 10) * 0.05; // Faster random movement
    laser.position.y += Math.cos(time + Math.random() * 10) * 0.05;
    laser.position.z += Math.sin(time + Math.random() * 10) * 0.05;
  });

  // Move camera more smoothly
  camera.position.x = Math.sin(time * 0.05) * 5; // Slower movement
  camera.position.y = Math.cos(time * 0.05) * 5;
  camera.position.z = 5 + Math.sin(time * 0.03) * 2; // Smoother oscillation

  camera.lookAt(scene.position);

  // Smoothly interpolate between the current and target background colors
  currentColor.lerp(targetColor, colorChangeSpeed);

  // Occasionally change the target color to create a slow fade effect
  if (Math.random() < 0.01) {
    targetColor.setRGB(Math.random(), Math.random(), Math.random());
  }

  // Set the background color to the interpolated color
  scene.background = currentColor;

  // Update stars rotation
  stars.rotation.x += 0.001;
  stars.rotation.y += 0.001;

  // Make lasers oscillate more smoothly
  time += 0.02;

  // Render the scene
  renderer.render(scene, camera);
}

animate();

// Handle resizing of the window
window.addEventListener('resize', () => {
  renderer.setSize(window.innerWidth, window.innerHeight);
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
});
